import type { SVGProps } from "react";

export default function UploadIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.5 12.4995C2.5 14.8565 2.5 16.035 3.23223 16.7673C3.96447 17.4995 5.14298 17.4995 7.5 17.4995H12.5C14.857 17.4995 16.0355 17.4995 16.7678 16.7673C17.5 16.035 17.5 14.8565 17.5 12.4995"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 13.3331V2.49976M10.0003 2.49976L13.3337 6.14559M10.0003 2.49976L6.66699 6.14559"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
